import PoLineException from './po-line-exception'
export default class ViewPoLineException {
    id:number;
    exceptionType:string;
    sku:string;
    exceptionQty:number;
    exceptionTypeName:string;
    productName:string;
    productId:number;
    orderQty:number;
    shortQty:number;
    editQty :number;
    showEdit:string='invisibleInput';
   items:Array<PoLineException>;
}